import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, Injectable } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import 'hammerjs';
import 'hammer-timejs';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { MonitorComponent } from './monitor/monitor.component';
import { appRoutingModule } from './app.routing';
import { NavigationComponent } from './navigation/navigation.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { SettingBarComponent } from './monitor/setting-bar/setting-bar.component';
import { MessagesComponent } from './HELPDESK/uredi-task/messages/messages.component';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';




//material
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatNativeDateModule } from '@angular/material/core';

import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatDividerModule } from '@angular/material/divider';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { NgChartsModule } from 'ng2-charts';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MonitorItemComponent } from './monitor-item/monitor-item.component';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { PrijaviNapakoComponent } from './HELPDESK/prijavi-napako/prijavi-napako.component';
import { LoginPartnerComponent } from './login-partner/login-partner.component';
import { PregledHelpdeskaComponent } from './HELPDESK/pregled-helpdeska/pregled-helpdeska.component';
import { UrediTaskComponent } from './HELPDESK/uredi-task/uredi-task.component';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { Constants } from './utils/constants';
import { MailContentComponent } from './HELPDESK/uredi-task/mail-content/mail-content.component';
import { DokumentiComponent } from './HELPDESK/uredi-task/dokumenti/dokumenti.component';
import { DokumentiDialogComponent } from './HELPDESK/uredi-task/dokumenti/dokumenti-dialog/dokumenti-dialog.component';
import { DolociProcesComponent } from './HELPDESK/uredi-task/doloci-proces/doloci-proces.component';
import { MailTokenComponent } from './HELPDESK/mail-token/mail-token.component';
import { AnalizaComponent } from './analiza/analiza.component';
import { LineChartComponent } from './analiza/line-chart/line-chart.component';
import { BarChartComponent } from './analiza/bar-chart/bar-chart.component';
import { BarChartWorkersComponent } from './analiza/bar-chart-workers/bar-chart-workers.component';
import { RadarChartWorkerStatusComponent } from './analiza/radar-chart-worker-status/radar-chart-worker-status.component';
import { BarChartProcessesComponent } from './analiza/bar-chart-processes/bar-chart-processes.component';
import { SaleHomeComponent } from './sale/sale-home/sale-home.component';
import { SaleSkladisceComponent } from './sale/sale-skladisce/sale-skladisce.component';
import { SaleUreComponent } from './sale/sale-ure/sale-ure.component';
import { SaleSkupinaComponent } from './sale/sale-skupina/sale-skupina.component';
import { SaleFilterComponent } from './sale/sale-filter/sale-filter.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { SaleSelectComponent } from './sale/sale-select/sale-select.component';
import { GrafSkladisceLetosLaniPieComponent } from './sale/graf-skladisce-letos-lani-pie/graf-skladisce-letos-lani-pie.component';
import { GrafSkladisceSaleDrzavePieComponent } from './sale/graf-skladisce-sale-drzave-pie/graf-skladisce-sale-drzave-pie.component';
import { GrafSkladisceLaniLetosDatumLineComponent } from './sale/graf-skladisce-lani-letos-datum-line/graf-skladisce-lani-letos-datum-line.component';
import { GrafSkladiscePoslovalniceStolpicniComponent } from './sale/graf-skladisce-poslovalnice-stolpicni/graf-skladisce-poslovalnice-stolpicni.component';
import { GrafSkladiscePrimerjavaGaugeComponent } from './sale/graf-skladisce-primerjava-gauge/graf-skladisce-primerjava-gauge.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { NgxGaugeModule } from 'ngx-gauge';
import { GrafSkladiscePrimerjavaStolpicniComponent } from './sale/graf-skladisce-primerjava-stolpicni/graf-skladisce-primerjava-stolpicni.component';
import { GrafUrePoUrahStolpicniComponent } from './sale/graf-ure-po-urah-stolpicni/graf-ure-po-urah-stolpicni.component';
import { AppConfigServiceService } from './services/app-config-service.service';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { UpdatePWAService } from './services/update-pwa.service';
import { SaleSkladisceDesktopComponent } from './sale/sale-skladisce-desktop/sale-skladisce-desktop.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SaleSkladisceTableComponent } from './sale/sale-skladisce-table/sale-skladisce-table.component';
import { GrafUrePoUrahStackedComponent } from './sale/graf-ure-po-urah-stacked/graf-ure-po-urah-stacked.component';
import { GrafSkladiscePrimerjavaPlanGaugeComponent } from './sale/graf-skladisce-primerjava-plan-gauge/graf-skladisce-primerjava-plan-gauge.component';
import { HelpdeskTabComponent } from './HELPDESK/helpdesk-tab/helpdesk-tab.component';
import { MapBubbleChartComponent } from './analiza/map-bubble-chart/map-bubble-chart.component';
import { DialogDodajDelavcaComponent } from './HELPDESK/dialog-dodaj-delavca/dialog-dodaj-delavca.component';
import { RepositoryComponent } from './repository/repository.component';
import { PodrobnoComponent } from './repository/podrobno/podrobno.component';
import { PodrobnoServerComponent } from './repository/podrobno-server/podrobno-server.component';
import { SideNavBarComponent } from './side-nav-bar/side-nav-bar.component';
import { FaqTabComponent } from './faq-tab/faq-tab.component';
import { MessagesTabComponent } from './messages-tab/messages-tab.component';
import {AccordionModule} from 'primeng/accordion';
import { AplikacijaHomeComponent } from './aplikacija/aplikacija-home/aplikacija-home.component';
import { IzbiraSkladiscaComponent } from './aplikacija/izbira-skladisca/izbira-skladisca.component';
import {Component, ElementRef, ViewChild} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import { AplikacijaHomeDocumentComponent } from './aplikacija/aplikacija-home-document/aplikacija-home-document.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxScannerQrcodeModule, LOAD_WASM } from 'ngx-scanner-qrcode';
import { StatusServerComponent } from './status_server/status-server/status-server.component';
import { TranslocoRootModule } from './transloco-root.module';
import { FaqVideoComponent } from './faq-video/faq-video.component';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule, VgVolumeComponent } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';



@Injectable()
export class HammerConfig extends HammerGestureConfig {
  overrides = <any>{
    'pinch': { enable: false },
    'rotate': { enable: false }
  }
}

LOAD_WASM().subscribe();

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        MonitorComponent,
        NavigationComponent,
        FooterComponent,
        SettingBarComponent,
        MonitorItemComponent,
        PrijaviNapakoComponent,
        LoginPartnerComponent,
        PregledHelpdeskaComponent,
        UrediTaskComponent,
        DragAndDropDirective,
        MessagesComponent,
        MailContentComponent,
        DokumentiComponent,
        DokumentiDialogComponent,
        DolociProcesComponent,
        MailTokenComponent,
        AnalizaComponent,
        LineChartComponent,
        BarChartComponent,
        BarChartWorkersComponent,
        RadarChartWorkerStatusComponent,
        BarChartProcessesComponent,
        SaleHomeComponent,
        SaleSkladisceComponent,
        SaleUreComponent,
        SaleSkupinaComponent,
        SaleFilterComponent,
        SaleSelectComponent,
        GrafSkladisceLetosLaniPieComponent,
        GrafSkladisceSaleDrzavePieComponent,
        GrafSkladisceLaniLetosDatumLineComponent,
        GrafSkladiscePoslovalniceStolpicniComponent,
        GrafSkladiscePrimerjavaGaugeComponent,
        GrafSkladiscePrimerjavaStolpicniComponent,
        GrafUrePoUrahStolpicniComponent,
        SaleSkladisceDesktopComponent,
        SaleSkladisceTableComponent,
        GrafUrePoUrahStackedComponent,
        GrafSkladiscePrimerjavaPlanGaugeComponent,
        HelpdeskTabComponent,
        MapBubbleChartComponent,
        DialogDodajDelavcaComponent,
        RepositoryComponent,
        PodrobnoComponent,
        PodrobnoServerComponent,
        SideNavBarComponent,
        FaqTabComponent,
        LineChartComponent,
        AplikacijaHomeComponent,
        MessagesTabComponent,
        IzbiraSkladiscaComponent,
        IzbiraSkladiscaComponent,
        AplikacijaHomeDocumentComponent,
        StatusServerComponent,
        FaqVideoComponent,
        
    ],
    imports: [
        MatListModule,
        BrowserAnimationsModule,
        NgChartsModule,
        MatTabsModule,
        MatSidenavModule,
        MatExpansionModule,
        MatSortModule,
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        FormsModule,
        appRoutingModule,
        BrowserAnimationsModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        FontAwesomeModule,
        MatSnackBarModule,
        MatTableModule,
        MatPaginatorModule,
        MatCardModule,
        MatSortModule,
        MatInputModule,
        MatButtonModule,
        MatDividerModule,
        FlexLayoutModule,
        MatMenuModule,
        MatTabsModule,
        MatIconModule,
        MatBadgeModule,
        MatDatepickerModule,
        MatNativeDateModule,
        AngularEditorModule,
        MatSidenavModule,
        MatToolbarModule,
        MatDialogModule,
        MatCheckboxModule,
        NgChartsModule,
        MatRadioModule,
        MatExpansionModule,
        MatSelectModule,
        GoogleChartsModule.forRoot(),
        NgxGaugeModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        MatButtonToggleModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        AccordionModule,
        InputGroupModule,
        FormsModule,
        ReactiveFormsModule,
        AsyncPipe,
        InputGroupAddonModule,   
        MatSnackBarModule,     
        BrowserModule,   
        FormsModule,
        NgxScannerQrcodeModule,
        TranslocoRootModule,     
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule
    ],
    providers: [{ provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: HammerConfig
        },
        MatDatepickerModule,
        Constants,
        MatSnackBar,
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [AppConfigServiceService],
            useFactory: (appConfigService: AppConfigServiceService) => {
                return () => {
                    //Make sure to return a promise!
                    return appConfigService.loadAppConfig();
                };
            }
        },
        UpdatePWAService],
    bootstrap: [AppComponent]
})
export class AppModule { }
